export const

    SET_VISITOR_ID = 'SET_VISITOR_ID',
    SET_VISITOR_NAME = 'SET_VISITOR_NAME',
    SET_VISITOR_EMAIL = 'SET_VISITOR_EMAIL',
    SET_VISITOR_TOKEN = 'SET_VISITOR_TOKEN',
    SET_VISITOR_URL = 'SET_VISITOR_URL',
    SET_VISITOR_DOMAIN = 'SET_VISITOR_DOMAIN',
    SET_ROUTE_INFO = 'SET_ROUTE_INFO';



// WEBPACK FOOTER //
// ./common/js/redux/actions/types.js